import { CodeOutlined } from '@ant-design/icons';
import React from 'react';

export const TextIcon = React.memo(() => {
  return (
    <>
      <svg
        aria-hidden="true"
        role="graphics-symbol"
        viewBox="0 0 20 20"
        className="text"
        style={{ flexShrink: 0 }}
        fill="currentColor"
      >
        <path d="M4.25 4A.75.75 0 015 3.25h10a.75.75 0 01.75.75v2a.75.75 0 01-1.5 0V4.75h-3.5v10.5h.75a.75.75 0 010 1.5h-3a.75.75 0 010-1.5h.75V4.75h-3.5V6a.75.75 0 01-1.5 0V4z"></path>
      </svg>
    </>
  );
});

export const Heading1Icon = React.memo(() => {
  return (
    <>
      <svg
        aria-hidden="true"
        role="graphics-symbol"
        viewBox="0 0 20 20"
        className="heading1"
        style={{ flexShrink: 0 }}
        fill="currentColor"
      >
        <path d="M3.75 4.87a.75.75 0 10-1.5 0v10.5a.75.75 0 001.5 0v-4.25h5.5v4.25a.75.75 0 001.5 0V4.87a.75.75 0 00-1.5 0v4.75h-5.5V4.87zM15.2 6.147a.75.75 0 01.55.723v7.75h1a.75.75 0 010 1.5H13a.75.75 0 110-1.5h1.25V8.663a2.52 2.52 0 01-1 .207.75.75 0 010-1.5c.357 0 .688-.187.871-.493l.236-.393a.75.75 0 01.843-.337z"></path>
      </svg>
    </>
  );
});

export const Heading2Icon = React.memo(() => {
  return (
    <svg
      aria-hidden="true"
      role="graphics-symbol"
      viewBox="0 0 20 20"
      className="heading2"
      style={{ flexShrink: 0 }}
      fill="currentColor"
    >
      <path d="M3.75 4.87a.75.75 0 10-1.5 0v10.5a.75.75 0 001.5 0v-4.25h5.5v4.25a.75.75 0 001.5 0V4.87a.75.75 0 00-1.5 0v4.75h-5.5V4.87zm13.5 11.25H12.5a.75.75 0 01-.557-1.252l3.904-4.338a1.57 1.57 0 00.403-1.05 1.36 1.36 0 00-1.36-1.36h-.136c-.687 0-1.285.467-1.452 1.133l-.074.299a.75.75 0 01-1.456-.364l.075-.298a2.996 2.996 0 012.907-2.27h.136a2.86 2.86 0 012.86 2.86c0 .758-.28 1.49-.788 2.054l-2.778 3.086h3.066a.75.75 0 010 1.5z"></path>
    </svg>
  );
});

export const Heading3Icon = React.memo(() => {
  return (
    <svg
      aria-hidden="true"
      role="graphics-symbol"
      viewBox="0 0 20 20"
      className="heading3"
      style={{ flexShrink: 0 }}
      fill="currentColor"
    >
      <path d="M3.75 4.87a.75.75 0 10-1.5 0v10.5a.75.75 0 001.5 0v-4.25h5.5v4.25a.75.75 0 001.5 0V4.87a.75.75 0 00-1.5 0v4.75h-5.5V4.87zm8.5 2.5a.75.75 0 01.75-.75h3.5a.75.75 0 01.576 1.23l-1.62 1.945a3.37 3.37 0 012.294 3.194v.135a2.996 2.996 0 01-5.903.727l-.075-.299a.75.75 0 111.456-.364l.074.299a1.496 1.496 0 002.948-.363v-.135a1.87 1.87 0 00-1.87-1.869H14a.75.75 0 01-.576-1.23l1.475-1.77H13a.75.75 0 01-.75-.75z"></path>
    </svg>
  );
});

export const CodeIcon = React.memo(() => {
  return <CodeOutlined style={{ fontSize: '20px' }} />;
});

export const CodeBlockIcon = React.memo(() => {
  return (
    <svg
      aria-hidden="true"
      role="graphics-symbol"
      viewBox="0 0 20 20"
      className="codeBlock"
      style={{ flexShrink: 0 }}
      fill="currentColor"
    >
      <path d="M11.741 3.614a.75.75 0 00-1.482-.228l-2 13a.75.75 0 001.482.228l2-13zM18.247 10l-3.933 4.494a.75.75 0 11-1.128-.988L16.253 10l-3.067-3.506a.75.75 0 111.128-.988L18.247 10zm-16.994.077l3.933-4.494a.75.75 0 111.128.988l-3.067 3.506 3.067 3.506a.75.75 0 11-1.128.988l-3.933-4.494z"></path>
    </svg>
  );
});

export const BulletListIcon = React.memo(() => {
  return (
    <svg
      aria-hidden="true"
      role="graphics-symbol"
      viewBox="0 0 20 20"
      className="bulletedList"
      style={{ flexShrink: 0 }}
      fill="currentColor"
    >
      <path d="M6.5 6A1.75 1.75 0 113 6a1.75 1.75 0 013.5 0zm3-.75a.75.75 0 000 1.5H17a.75.75 0 000-1.5H9.5zm0 8a.75.75 0 000 1.5H17a.75.75 0 000-1.5H9.5zm-4.75 2.5a1.75 1.75 0 100-3.5 1.75 1.75 0 000 3.5z"></path>
    </svg>
  );
});

export const NumberListIcon = React.memo(() => {
  return (
    <svg
      aria-hidden="true"
      role="graphics-symbol"
      viewBox="0 0 20 20"
      className="numberedList"
      style={{ flexShrink: 0 }}
      fill="currentColor"
    >
      <path d="M5.126 2.961c.19.113.308.318.308.539v4a.625.625 0 11-1.25 0V4.562l-.13.073a.625.625 0 11-.608-1.093l1.06-.588a.625.625 0 01.62.007zM8.5 5.25a.75.75 0 000 1.5H16a.75.75 0 000-1.5H8.5zm0 8a.75.75 0 000 1.5H16a.75.75 0 000-1.5H8.5zM6 16.625H3.5a.625.625 0 01-.474-1.032l1.923-2.24a.614.614 0 00.148-.4.26.26 0 00-.206-.255l-.164-.035a.48.48 0 00-.213.003l-.029.008a.499.499 0 00-.37.38.625.625 0 11-1.228-.234 1.748 1.748 0 011.303-1.36l.03-.008a1.73 1.73 0 01.765-.01l.164.034a1.51 1.51 0 011.197 1.478c0 .445-.16.876-.45 1.214L4.86 15.375H6a.625.625 0 110 1.25z"></path>
    </svg>
  );
});

export const TodoListIcon = React.memo(() => {
  return (
    <svg
      aria-hidden="true"
      role="graphics-symbol"
      viewBox="0 0 20 20"
      className="todoList"
      style={{ flexShrink: 0 }}
      fill="currentColor"
    >
      <path d="M8.064 4.494a.75.75 0 00-1.128-.988L4.024 6.833l-.94-1.17a.75.75 0 00-1.169.94l1.5 1.867a.75.75 0 001.15.024l3.5-4zm0 8a.75.75 0 00-1.128-.988l-2.912 3.327-.94-1.17a.75.75 0 00-1.169.94l1.5 1.867a.75.75 0 001.15.024l3.5-4zM8.75 6a.75.75 0 01.75-.75H17a.75.75 0 010 1.5H9.5A.75.75 0 018.75 6zm.75 7.25a.75.75 0 000 1.5H17a.75.75 0 000-1.5H9.5z"></path>
    </svg>
  );
});

export const QuoteIcon = React.memo(() => {
  return (
    <svg
      aria-hidden="true"
      role="graphics-symbol"
      viewBox="0 0 20 20"
      className="quoteBlock"
      style={{ flexShrink: 0 }}
      fill="currentColor"
    >
      <path d="M7.038 5.25a4.788 4.788 0 00-4.788 4.789v.576a4.211 4.211 0 004.212 4.212 3.058 3.058 0 10-2.712-4.472v-.316A3.288 3.288 0 017.038 6.75h.577a.75.75 0 100-1.5h-.577zm3.442 4.789a4.788 4.788 0 014.79-4.789h.576a.75.75 0 010 1.5h-.577a3.288 3.288 0 00-3.288 3.289v.316a3.057 3.057 0 112.711 4.472 4.211 4.211 0 01-4.211-4.212v-.576z"></path>
    </svg>
  );
});

export const TickOutlined = React.memo(() => {
  return (
    <svg
      aria-hidden="true"
      role="graphics-symbol"
      viewBox="0 0 16 16"
      className="thinCheck"
      width={'16px'}
      height={'16px'}
      style={{ flexShrink: 0 }}
      fill="currentColor"
    >
      <path d="M6.385 14.162c.362 0 .642-.15.84-.444L13.652 3.71c.144-.226.205-.417.205-.602 0-.485-.341-.82-.833-.82-.335 0-.54.123-.746.444l-5.926 9.4-3.042-3.903c-.205-.267-.417-.376-.718-.376-.492 0-.848.348-.848.827 0 .212.075.417.253.629l3.541 4.416c.24.3.492.437.848.437z"></path>
    </svg>
  );
});

export const InlineCommentIcon = React.memo(() => (
  <svg
    aria-hidden="true"
    role="graphics-symbol"
    viewBox="0 0 16 16"
    className="speechBubbleFilled"
    style={{
      width: '16px',
      height: '16px',
      display: 'block',
      fill: 'inherit',
      flexShrink: 0,
      marginTop: '1px',
    }}
  >
    <path d="M4.32 15.424c.39 0 .677-.192 1.149-.609l2.344-2.064h4.116c2.057 0 3.213-1.19 3.213-3.22V4.22c0-2.03-1.156-3.22-3.213-3.22H3.213C1.163 1 0 2.19 0 4.22V9.53c0 2.037 1.196 3.22 3.165 3.22h.28v1.675c0 .608.322.998.875.998zm.342-1.531v-1.949c0-.403-.178-.56-.56-.56H3.26c-1.285 0-1.9-.65-1.9-1.894V4.26c0-1.243.615-1.893 1.9-1.893h8.627c1.278 0 1.893.65 1.893 1.894v5.23c0 1.243-.615 1.893-1.893 1.893h-4.15c-.417 0-.622.068-.909.369l-2.167 2.14zm-.567-8.668h6.884a.433.433 0 00.423-.438.425.425 0 00-.423-.417H4.095a.419.419 0 00-.417.417c0 .24.184.438.417.438zm0 2.167h6.884a.427.427 0 000-.855H4.095a.425.425 0 00-.417.424c0 .24.184.43.417.43zm0 2.173h4.484c.24 0 .424-.191.424-.423 0-.24-.185-.431-.424-.431H4.095a.422.422 0 00-.417.43.42.42 0 00.417.424z"></path>
  </svg>
));
